import { defaultHttpClient } from '../../httpClient';
import type { SizeReviewAnalysisResponse } from './types';

export const getSizeReviewAnalysis = (goodsSno: number) => {
  return defaultHttpClient
    .request<SizeReviewAnalysisResponse>({
      method: 'GET',
      url: `/webview/goods/${goodsSno}/reviews/size-analysis`,
    })
    .then(result => result.data);
};
